import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/trello': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M392.3 32H56.1C25.1 32 0 57.1 0 88-0.1 88 0 84 0 424 0 454.9 25.1 480 56 480H392.2C423 479.8 447.9 454.8 447.9 424V88C448 57.2 423.1 32.2 392.3 32zM197 371.3C196.8 386 184.9 397.9 170.1 397.9H87.4C72.6 398 60.5 386.1 60.4 371.3V117.1C60.4 102.3 72.4 90.2 87.3 90.2H170.2C185 90.2 197.1 102.2 197.1 117.1V371.3zM390.1 259.3C390.1 274.1 378.1 286.2 363.2 286.2H282.2C267.4 286.2 255.3 274.2 255.3 259.3V117.2C255.3 102.4 267.3 90.3 282.1 90.3H363.2C378 90.3 390.1 102.3 390.1 117.2V259.3z'
      }
    ]
  }
})
